import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import CaseStudy from '../../components/CaseStudy/CaseStudy';

const CaseStudyPage = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <CaseStudy />
    </ProtectedRoute>
  );
};

export default CaseStudyPage;